import React, { Component } from 'react';
import { ReactComponent as Logo }from './img/tj-logo.svg';
import Intro from './components/intro';
import Success from './components/success';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

import './styles/styles.scss';

ReactGA.initialize('UA-4179347-6');
ReactGA.pageview(window.location.href);
ReactPixel.init('274386402765456');
ReactPixel.pageView();

function validate(email){
  // eslint-disable-next-line
  const emailCheck = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if(email.length > 2 && email.includes('@') && email.match(emailCheck))
    return true
  else 
    return false
}
class App extends Component {
  constructor(props){
    super(props);

    this.state = {
      isSubmitted: false,
      disableButton: true,
      canBeSubmitted: false,
      email:'',
      errors: false
    }

    
  }
  handleChange = (name,{disableButton} = this.state) => e => {
    e.preventDefault();
    console.log(e.target.value,"this was changed" , name)
    if(e.target.value !== '' && e.target.value.length > 2){
      console.log("this is now valid")
      this.setState({
         [name]: e.target.value,
         disableButton: false
      }
      )
    }else if (e.target.value == null || e.target.value.length <=0 || undefined || e.target.value === ''){
      this.setState({
        errors: false
      })
    }
  }


  handleSubmit = (form, {email, errors, canBeSubmitted} = this.state) => e => {
    e.preventDefault();
    if(validate(email)) {
      this.setState({
        canBeSubmitted: !canBeSubmitted,
      })
      this.sendToBronto(email)
      console.log('form can be submitted')
    }else{
      console.log('form is not ready to be submitted', validate(email))
      this.setState({
        errors: !errors
      })
    }
   
  }
  canBeSubmittedCheck(){
  
  }
  sendToBronto(email){
    let address = `https://app.bronto.com/public/?q=direct_add&fn=Public_DirectAddForm&id=cakgcxnoenblvpkrjxmropogmsfsbgl&email=${email}&list1=0bcd03ec00000000000000000000001de5a4`
    return fetch(address,{
      mode:'no-cors'
    })
  }
  whichView () {
    const {isSubmitted, canBeSubmitted, errors, disableButton } = this.state
    const error = validate(this.state.email)
    console.log(error);
    if(canBeSubmitted){
      return  <Success /> 
    }else 
      return <Intro handleChange={this.handleChange} handleSubmit={this.handleSubmit} isSubmited={isSubmitted} canBeSubmitted={canBeSubmitted} errors={errors} disableButton={disableButton}/>

  }
  render(){
 
    return (
      <div className="container">
      <main className="earlyAccess">
    <Logo/>
      {
        this.whichView(this.state)
      }
        </main>
      </div>
    );
  }
  
}

export default App;
